import VisaIcon from '../Images/visa.svg';
import MastercardIcon from '../Images/mastercard.svg';
import DinersIcon from '../Images/diners.svg';
import AmexIcon from '../Images/amex.svg';
import DiscoverIcon from '../Images/discover.svg';
import HipercardIcon from '../Images/hipercard.svg';
import EloIcon from '../Images/elo.svg';
import JcbIcon from '../Images/jcb.svg';
import AuraIcon from '../Images/aura.svg';
import DefaultCardIcon from '../Images/default-card.svg';

export function getCardFlag(number) {
  var cardNumber = number.replace(/[^0-9]+/g, '');

  var cards = {
    elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
    visa: /^4[0-9]{12}(?:[0-9]{3})/,
    mastercard: /^5[1-5][0-9]{14}/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
    amex: /^3[47][0-9]{13}/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
    hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
    aura: /^(5078\d{2})(\d{2})(\d{11})$/,
  };

  for (var flag in cards) {
    if (cards[flag].test(cardNumber)) {
      return flag;
    }
  }

  return false;
}

export function getFlagIcon(flag) {
  if (flag === 'visa') {
    return VisaIcon;
  } else if (flag === 'mastercard') {
    return MastercardIcon;
  } else if (flag === 'diners') {
    return DinersIcon;
  } else if (flag === 'amex') {
    return AmexIcon;
  } else if (flag === 'hipercard') {
    return HipercardIcon;
  } else if (flag === 'elo') {
    return EloIcon;
  } else if (flag === 'jcb') {
    return JcbIcon;
  } else if (flag === 'aura') {
    return AuraIcon;
  } else if (flag === 'discover') {
    return DiscoverIcon;
  } else {
    return DefaultCardIcon;
  }
}

export function getInstallmentValues(price) {
  var values = [];
  for (var i = 1; i <= 12; i++) {
    var totalValue = price;
    // Add installment tax
    if (i === 2) {
      totalValue += totalValue * 0.0467;
    } else if (i === 3) {
      totalValue += totalValue * 0.0626;
    } else if (i === 4) {
      totalValue += totalValue * 0.0785;
    } else if (i === 5) {
      totalValue += totalValue * 0.0948;
    } else if (i === 6) {
      totalValue += totalValue * 0.1111;
    } else if (i === 7) {
      totalValue += totalValue * 0.1277;
    } else if (i === 8) {
      totalValue += totalValue * 0.1445;
    } else if (i === 9) {
      totalValue += totalValue * 0.1613;
    } else if (i === 10) {
      totalValue += totalValue * 0.1783;
    } else if (i === 11) {
      totalValue += totalValue * 0.1956;
    } else if (i === 12) {
      totalValue += totalValue * 0.213;
    }
    totalValue = Number(totalValue.toFixed(2));
    values.push({
      installments: i,
      price: totalValue,
    });
  }

  return values;
}
